import { DCRecord } from "@/@types/lib/dataController";
import { ParsedRouteWarning } from "@/@types/services/mapService";

export const ROUTE_WARNING_AREA_STORAGE_KEY = "routeWarningPodrucja";
export const ROUTE_WARNING_MSP_STORAGE_KEY = "routeWarningMSP";

const parseStoredWarnings = (key: string): ParsedRouteWarning[] => {
  if (typeof window === "undefined") {
    return [];
  }

  const rawValue = localStorage.getItem(key);

  if (!rawValue) {
    return [];
  }

  try {
    return JSON.parse(rawValue) as ParsedRouteWarning[];
  } catch (e) {
    console.error("Greška pri parsiranju warnings iz localStorage:", e);
    return [];
  }
};

export const parseRouteWarnings = (record?: DCRecord) => {
  const warningsMSP = record?.warnings_msp
    ? (record.warnings_msp as DCRecord[]).map((warning) => {
      return { ...warning, warning_type: "MSP", id: warning.msp_id } as ParsedRouteWarning;
    })
    : ([] as ParsedRouteWarning[]);

  const warningsPodrucja = record?.warnings_podrucja
    ? (record.warnings_podrucja as DCRecord[]).map((warning) => {
      return { ...warning, warning_type: "podrucja", id: warning.podrucje_id } as ParsedRouteWarning;
    })
    : ([] as ParsedRouteWarning[]);

  return {
    warningsMSP,
    warningsPodrucja,
    warnings: [...warningsMSP, ...warningsPodrucja],
  };
};

export const shuffleWarnings = <T,>(warnings: T[]): T[] => {
  return warnings
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
};

export const getStoredRouteWarnings = () => {
  const warningsPodrucja = parseStoredWarnings(ROUTE_WARNING_AREA_STORAGE_KEY);
  const warningsMSP = parseStoredWarnings(ROUTE_WARNING_MSP_STORAGE_KEY);

  return {
    warningsPodrucja,
    warningsMSP,
    warnings: [...warningsMSP, ...warningsPodrucja],
  };
};

export const storeRouteWarnings = (
  warningsMSP: ParsedRouteWarning[],
  warningsPodrucja: ParsedRouteWarning[]
) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.setItem(ROUTE_WARNING_AREA_STORAGE_KEY, JSON.stringify(warningsPodrucja));
  } catch (e) {
    console.error("Greška pri spremanju area warnings u localStorage:", e);
  }

  try {
    localStorage.setItem(ROUTE_WARNING_MSP_STORAGE_KEY, JSON.stringify(warningsMSP));
  } catch (e) {
    console.error("Greška pri spremanju msp warnings u localStorage:", e);
  }
};

export const areWarningsIdentical = (
  previousWarnings: ParsedRouteWarning[],
  nextWarnings: ParsedRouteWarning[]
) => {
  return (
    (previousWarnings.length === 0 && nextWarnings.length === 0) ||
    (
      previousWarnings.length > 0 &&
      nextWarnings.length > 0 &&
      previousWarnings[0].id === nextWarnings[0].id
    )
  );
};
